import BigNumber from 'bignumber.js';
export type BigNumberish = number | string | BigNumber | bigint;
export const formatMoneyNumber = (num: number, decimal = 2) =>
  Intl.NumberFormat('en-es', {
    maximumFractionDigits: decimal,
  }).format(num);

export const formatNumberInFixedDecimal = (
  num: number | string,
  decimal = 2
) => {
  const numStr = num.toString();
  const [integer, digital = ''] = numStr.split('.');
  if (decimal === 0) return integer;
  const digitalLen = digital.length;
  const slicedDigital =
    digitalLen > decimal
      ? digital.slice(0, decimal)
      : digital.padEnd(decimal, '0');
  return `${integer}.${slicedDigital}`;
};
